/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-a26b9c60.mjs';
import { TreeItemDefinition, useRipple, getCreateElement } from './adapt.mjs';
import useItemState from './hooks/useItemState.mjs';
import useTreeItem from './hooks/useTreeItem.mjs';
import { defineComponent, ref } from 'vue';
import '../_chunks/dep-b333ab93.mjs';
import '../utils/withInstall.mjs';
import '../hooks/useVModel.mjs';
import '../_chunks/dep-8747fcf0.mjs';
import '../_chunks/dep-6f3e4f56.mjs';
import '../_chunks/dep-17446155.mjs';
import '../_chunks/dep-7ad89920.mjs';
import '../_chunks/dep-b1060562.mjs';
import '../_chunks/dep-0d1bd08c.mjs';
import '../_chunks/dep-c5d88cfe.mjs';
import '../_chunks/dep-36563716.mjs';
import '../_chunks/dep-8049d2e0.mjs';
import '../hooks/useDefaultValue.mjs';
import 'tdesign-icons-vue-next';
import '../checkbox/index.mjs';
import '../checkbox/checkbox.mjs';
import '../_chunks/dep-89b33ff6.mjs';
import '../_chunks/dep-6bcce672.mjs';
import '../checkbox/props.mjs';
import '../hooks/useRipple.mjs';
import '../hooks/useKeepAnimation.mjs';
import '../hooks/useConfig.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-97c71289.mjs';
import '../_chunks/dep-4efc69ee.mjs';
import '../_chunks/dep-493c38ce.mjs';
import '../_chunks/dep-b56b2dc0.mjs';
import '../_chunks/dep-77f634fb.mjs';
import '../_chunks/dep-28ae3cda.mjs';
import '../_chunks/dep-e50fa7b0.mjs';
import '../_chunks/dep-ae08d6c4.mjs';
import '../_chunks/dep-7211604f.mjs';
import '../_chunks/dep-75df64b1.mjs';
import '../_chunks/dep-48b9a098.mjs';
import '../_chunks/dep-c7e4942d.mjs';
import '../_chunks/dep-25d66c95.mjs';
import '../_chunks/dep-372265bb.mjs';
import '../_chunks/dep-d940e2da.mjs';
import '../_chunks/dep-52c1d6a9.mjs';
import '../_chunks/dep-18bb982b.mjs';
import '../_chunks/dep-c57d8117.mjs';
import '../_chunks/dep-6043e9fc.mjs';
import '../_chunks/dep-5f6c8826.mjs';
import '../_chunks/dep-3a045465.mjs';
import '../_chunks/dep-53dc0ac1.mjs';
import '../_chunks/dep-b6b4eaa3.mjs';
import '../_chunks/dep-881cffb7.mjs';
import '../_chunks/dep-436b338d.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-2d31a683.mjs';
import '../_chunks/dep-3ddc95d0.mjs';
import '../config-provider/type.mjs';
import '../utils/set-style.mjs';
import '../hooks/tnode.mjs';
import '../_chunks/dep-0a6fd248.mjs';
import '../_chunks/dep-b1013215.mjs';
import '../_chunks/dep-91fc304f.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-ec227f3f.mjs';
import '../checkbox/constants.mjs';
import '../checkbox/hooks/useCheckboxLazyLoad.mjs';
import '../_common/js/utils/observe.mjs';
import '../checkbox/hooks/useKeyboardEvent.mjs';
import '../_common/js/common.mjs';
import '../hooks/useDisabled.mjs';
import '../_chunks/dep-11ebe61f.mjs';
import '../checkbox/group.mjs';
import '../_chunks/dep-f7837681.mjs';
import '../_chunks/dep-c0b45aa7.mjs';
import '../_chunks/dep-8a9a248b.mjs';
import '../_chunks/dep-ce88e3c0.mjs';
import '../checkbox/checkbox-group-props.mjs';
import '../hooks/slot.mjs';
import './style/css.mjs';
import '../checkbox/type.mjs';
import '../loading/index.mjs';
import '../loading/directive.mjs';
import '../loading/plugin.mjs';
import '../loading/loading.mjs';
import '../loading/icon/gradient.mjs';
import '../_common/js/loading/circle-adapter.mjs';
import '../_common/js/utils/set-style.mjs';
import '../_common/js/utils/helper.mjs';
import '../_chunks/dep-9c7a32ff.mjs';
import '../_chunks/dep-c45cdd10.mjs';
import '../_chunks/dep-a432d90f.mjs';
import '../utils/dom.mjs';
import '../utils/easing.mjs';
import '../loading/props.mjs';
import '../hooks/useTeleport.mjs';
import '../loading/type.mjs';
import '../hooks/useGlobalIcon.mjs';
import '../hooks/useLazyLoad.mjs';
import '../hooks/useVirtualScrollNew.mjs';
import '../hooks/useResizeObserver.mjs';
import '../_common/js/tree/tree-node.mjs';
import '../_chunks/dep-fc0ecd7a.mjs';
import '../_chunks/dep-6d195cc7.mjs';
import '../_chunks/dep-2311acd8.mjs';
import '../_chunks/dep-87c358ba.mjs';
import '../_chunks/dep-6e04bcaa.mjs';
import '../_common/js/tree/tree-node-model.mjs';
import '../_chunks/dep-7cc8d2c3.mjs';
import '../_chunks/dep-d23f3733.mjs';
import '../_chunks/dep-4b3e18ca.mjs';
import '../_common/js/log/log.mjs';
import '../_common/js/log/index.mjs';
import './hooks/useItemEvents.mjs';
import './hooks/useRenderIcon.mjs';
import './util.mjs';
import './hooks/useRenderLabel.mjs';
import './hooks/useRenderLine.mjs';
import './hooks/useRenderOperations.mjs';
import './hooks/useDraggable.mjs';
import '../_chunks/dep-99b45a9d.mjs';
import '../_chunks/dep-9239b808.mjs';
import '../_chunks/dep-8bda6dda.mjs';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var treeItemProps = {
  stateId: {
    type: String
  },
  itemKey: {
    type: String
  },
  rowIndex: {
    type: Number
  },
  treeScope: {
    type: Object
  }
};
var TreeItem = defineComponent(_objectSpread(_objectSpread({
  props: treeItemProps
}, TreeItemDefinition), {}, {
  setup: function setup(props, context) {
    var _useItemState = useItemState(props, context),
      state = _useItemState.state;
    var treeItemRef = state.treeItemRef;
    var label = ref();
    useRipple(label);
    var _useTreeItem = useTreeItem(state),
      renderItemNode = _useTreeItem.renderItemNode;
    return {
      treeItemRef: treeItemRef,
      renderItemNode: renderItemNode
    };
  },
  render: function render(h) {
    var createElement = getCreateElement(h);
    if (typeof this.renderItemNode === "function") {
      return this.renderItemNode(createElement);
    }
    return null;
  }
}));

export { TreeItem as default, treeItemProps };
//# sourceMappingURL=tree-item.mjs.map
